/**
 * Anwendungsversion in der Oberfläche (§36).
 *
 * Der Wert wird zur Bauzeit aus `apps/frontend/package.json` eingesetzt (siehe `vite.config.ts`).
 * `version.test.ts` hält beide zusammen — dieselbe Zusicherung, die im Backend zwischen
 * `src/version.ts` und `package.json` gilt.
 */
export const APP_VERSION: string = __APP_VERSION__;
